import React, { useEffect, useState } from 'react';
import { SignOutButton } from '../auth/SignInButton';

/**
 * Full-screen banner shown when the active tenant has been suspended or
 * cancelled by Marketplace. The fetch interceptor in src/auth/msalConfig.js
 * dispatches the lifecycle events; this component listens at the App level
 * and renders the overlay until the user reloads or signs out.
 */
export default function TenantLifecycleBanner() {
  const [state, setState] = useState(null); // null | 'suspended' | 'cancelled'

  useEffect(() => {
    const onSuspended = () => setState('suspended');
    const onCancelled = () => setState('cancelled');
    window.addEventListener('saara:tenant-suspended', onSuspended);
    window.addEventListener('saara:tenant-cancelled', onCancelled);
    return () => {
      window.removeEventListener('saara:tenant-suspended', onSuspended);
      window.removeEventListener('saara:tenant-cancelled', onCancelled);
    };
  }, []);

  if (!state) return null;

  const isCancelled = state === 'cancelled';
  const title = isCancelled ? 'This tenant has been cancelled' : 'Subscription paused';
  const detail = isCancelled
    ? 'Your SAARA subscription was cancelled and the tenant is no longer accessible. Existing data is retained for audit.'
    : 'Your SAARA subscription is currently suspended (commonly due to a payment issue). Reactivate via Microsoft Marketplace, then refresh.';
  const colour = isCancelled ? '#455A64' : '#C62828';
  const bg = isCancelled ? '#ECEFF1' : '#FFEBEE';

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(13,27,42,0.75)', zIndex: 200,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    }}>
      <div style={{ maxWidth: 460, background: '#fff', borderRadius: 12, padding: '28px 32px', borderTop: `4px solid ${colour}` }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: colour, marginBottom: 8, letterSpacing: '0.04em', textTransform: 'uppercase' }}>
          {isCancelled ? 'Tenant cancelled' : 'Subscription paused'}
        </div>
        <div style={{ fontSize: 18, fontWeight: 700, color: '#0D1B2A', marginBottom: 10 }}>{title}</div>
        <div style={{ fontSize: 12, color: '#455A64', lineHeight: 1.6, marginBottom: 18 }}>{detail}</div>
        <div style={{ padding: 12, background: bg, borderRadius: 6, fontSize: 11, color: colour, marginBottom: 18 }}>
          Contact your SAARA admin or Kloudynet support if you believe this is in error.
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          {!isCancelled && (
            <button className="btn-primary" style={{ flex: 1 }} onClick={() => window.location.reload()}>
              Refresh
            </button>
          )}
          <SignOutButton style={{
            flex: 1, padding: '8px 12px', fontSize: 12,
            background: '#F5F7F9', color: '#0D1B2A', border: '1px solid #E0E4E8', borderRadius: 6, cursor: 'pointer',
          }} />
        </div>
      </div>
    </div>
  );
}
